import "@fortawesome/fontawesome-free/js/all"

import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import Vuelidate from "vuelidate";
import VueDragscroll from 'vue-dragscroll'
import { abilitiesPlugin } from "@casl/vue";

import App from "./App";
import router from "./router/index";
import { resetRouter } from "./router/index";
import store from "./store";

import "./assets/scss/app.scss";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Vuelidate);
Vue.use(VueDragscroll);

Vue.prototype.appTitle = process.env.VUE_APP_TITLE;
Vue.prototype.isDebug = process.env.NODE_ENV !== 'production';

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
      el.clickOutsideEvent = function (event) {
        if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
        }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

/* eslint-disable no-new */
new Vue({
    store,
    router,
    render: h => h(App)
}).$mount("#app");

Vue.use(abilitiesPlugin, store.getters.ability);


router.app.$watch(
    function () {
        return store.getters.userId;
    },
    function (newVal, oldVal) {
        resetRouter();
    }
)
